import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Box } from '@mui/material';

function PostSideHeader({ i18nKey }: any) {
  return (
    <Box sx={{ backgroundColor: 'grey.800', color: 'white', paddingX: 2, paddingY: 1 }}>
      <FormattedMessage id={i18nKey} />
    </Box>
  );
}

PostSideHeader.propTypes = {
  i18nKey: PropTypes.string.isRequired,
};

export default PostSideHeader;
